<template>
  <div class="order-detail" id="order-detail">
    <div class="title">{{detail.title}}</div>
    <div class="status">订单状态：
      <span :class="{blue:detail.status == 0,red:detail.status == 2,green:detail.status == 1}">
        {{detail.status == 0?'未支付':""}}{{detail.status == 1?'已支付':""}}{{detail.status == 2?'已取消':""}}
      </span> 
    </div>
    <div class="result">订单结果：
      <span v-if="detail.insuranceResult != '投保成功'" style="color:red">{{detail.insuranceResult}}</span>
      <span v-else>{{detail.insuranceResult}}</span>
    </div>

    <!-- 保单明细 -->
    <div class="card">
      <div class="name"> <div class="bar2px"></div> 保单明细</div>
      <div class="card-ul">
        <div class="item width50">保障计划：{{detail.plan}}</div>
        <div class="item width100">被保人数：1</div>
        <!-- <div class="item width100">支付金额：￥{{detail.payPrice}}</div> -->
        <div class="item width100">保单号：{{detail.insuranceCode?detail.insuranceCode:'暂未生成保单'}}</div>
        <div class="item width100">保险期限：{{moment(detail.startDate).format("YYYY-MM-DD")}} 至 {{moment(detail.endDate).format("YYYY-MM-DD")}}</div>
      </div>
    </div>

    <div class="bar8px"></div>


    <!-- 保障责任 -->
    <div class="card">
      <div class="name"> <div class="bar2px"></div> 保障责任/保额</div>
      <div class="card-ul">
        <div class="item width100" v-for="(item,index) in summarys" :key="index"><img src="./assets/images/li.png" alt="">{{item.name}}<span class="price">{{item.price | countFilter}}元</span> </div>
      </div>
    </div>

    <div class="bar8px"></div>


    <!-- 投保人 -->
    <div class="card">
      <div class="name"> <div class="bar2px"></div> 投保人信息</div>
      <div class="card-ul">
        <div class="item width100 people"><span>姓名:</span> <span>{{detail.insurePeople.name}}</span> </div>
        <div class="item width100 people"><span>证件类型：</span> <span>{{detail.insurePeople.idType}}</span> </div>
        <div class="item width100 people"><span>证件号码：</span> <span>{{detail.insurePeople.idCode}}</span> </div>
        <div class="item width100 people"><span>性别：</span> <span>{{detail.insurePeople.sex == 1?'男':'女'}}</span> </div>
        <div class="item width100 people"><span>手机号码：</span> <span> {{detail.insurePeople.phone}}</span></div>
        <!-- <div class="item width100">联系地址：南山区大冲新城花园</div> -->
        <!-- <div class="item width100 people"><span>电子邮箱：</span> <span>{{detail.insurePeople.mailbox}}</span> </div> -->
      </div>
    </div>
   

    <div class="bar8px"></div>

    <!-- 被保人 -->
     <div class="card">
      <div class="name"> <div class="bar2px"></div> 被保人信息</div>
      <div class="card-ul">
        <div class="item width100 people"> <span>姓名:</span> <span></span> {{detail.name}}</div>
        <div class="item width100 people"><span>证件类型：</span> <span>{{detail.idType}}</span> </div>
        <div class="item width100 people"><span>证件号码：</span> <span>{{detail.idCode}}</span> </div>
         <div class="item width100 people"><span>性别：</span> <span>{{detail.sex == 1?'男':'女'}}</span> </div>
        <div class="item width100 people"><span>手机号码：</span> <span>{{detail.phone}}</span></div>
        <!-- <div class="item width100 people"><span>电子邮箱：</span> <span>{{detail.mailbox}}</span> </div> -->
      </div>
    </div>

    <!-- <div class="bar8px"></div> -->
  </div>
</template>

<script>
import storejs from "store";
import moment from 'moment';
import { Collapse, CollapseItem,Icon  } from 'vant';
import $ from "jquery";

export default {
  name: 'OrderList',
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]:CollapseItem,
    [Icon.name]:Icon
  },
  data(){
    return{
      moment:moment,
      publicData: storejs.get("publicData"),
      activeNames:[1],
      summarys:[],
      detail:{
        insurePeople:''
      }
    }
  },
  watch: {
  },
  mounted() {
    window.scroll(0, 0);
    document.body.scrollIntoView(true);
    this.initStyle()
    this.init()
    
  },
  beforeDestroy: function() {
    
  },
  methods: {
    initStyle(){
      // let el = document.getElementById('bg')
      let height = window.innerHeight
      $('#order-detail').css({'min-height':height + 'px'})
    },
    async init(){
      await this.getOrderDetail()
    },
    async getOrderDetail(){
      let res = await this.$http.post("api/bill/get", {id:this.$route.query.id});
      if(res.code == 0){
        res.t.insurePeople = JSON.parse(res.t.insurePeople)
        res.t.productPlan = JSON.parse(res.t.productPlan)
        res.t.productPlan.forEach((item,index)=>{
          if(item.name == res.t.plan){
            this.summarys = item.summarys
          }
        })
        this.detail = res.t
      }
      console.log(res)
    },
  },
}
</script>

<style lang="scss" scoped>
  .order-detail{
    font-size: 14px;
    padding: 10px 0px;
    box-sizing: border-box;
    .bar2px{
      width:2px;
      height:12px;
      margin-right: 6px;
      background: #00D385;
    }
    .bar8px{
      width:100%;
      height:8px;
      margin-right: 6px;
      background:rgba(244,244,244,1);
    }
    .title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(0,211,133,1);
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .status{
      font-size:12px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      height: 25px;
      line-height: 25px;
      padding: 0 10px;
      box-sizing: border-box;
      span{
        font-size: 12px;
        &.blue{
          color: #999999;
        }
        &.red{
          color: red;
        }
        &.green{
          color:rgba(0,211,133,1);
        }
      }
      
    }
    .result{
      font-size:12px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      height: 25px;
      line-height: 25px;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .card{
      padding: 10px;
      box-sizing: border-box;
      .name{
        display: flex;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1); 
        height: 30px;
        line-height: 30px;
        align-items: center;
      }
      .card-ul{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
          width: 50%;
          flex-shrink: 0;
          height: 25px;
          line-height: 25px;
          font-size:13px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(102,102,102,1);
          img{
            width: 8px;
            margin-right: 4px;
          }
          &.width100{
            width: 100%;
          }

          &.people{
            display: flex;
            justify-content: space-between;
          }

        }
      }
    }
  }
</style>

<style lang="scss">
  .order-detail{
    .van-cell{
      padding: 0;
    }
    .van-hairline--top-bottom::after{
      border-width: 0;
    }
    .van-collapse-item__title--expanded::after{
      display: none;
    }
    .van-cell__title{
      height: 30px;
      line-height: 30px;
    }
    .van-collapse-item__content{
      padding:0
    }
  }
</style>